import { useTranslation } from 'react-i18next'
import { Box, MenuItem } from '@mui/material'
import InputFormikField from '@/views/components/input-formik-field/index.component'

import { RolloverAmountCalculationEnum } from '@/enums'

type Props = {
  handleChangeSearch: (field: string, value: any) => void
}

export const RolloverAmountCalculationFilterType = ({
  handleChangeSearch,
}: Props) => {
  const { t } = useTranslation()

  const rolloverCalculation = [
    RolloverAmountCalculationEnum.lowerAmount,
    RolloverAmountCalculationEnum.riskAmount,
  ]

  const rolloverCalculationOptions = rolloverCalculation.map((rollover) => {
    return (
      <MenuItem key={rollover} value={rollover}>
        {`${t(`rolloverAmountCalculationType.${rollover}`)}`}
      </MenuItem>
    )
  })

  return (
    <InputFormikField
      name="rolloverAmountCalculation"
      label={t('transaction.raCalculation')}
      select
      margin="dense"
      onChange={(event) =>
        handleChangeSearch('rolloverAmountCalculation', event.target.value)
      }
    >
      <MenuItem value="all">
        <Box fontStyle="italic">{t('all')}</Box>
      </MenuItem>
      {rolloverCalculationOptions}
    </InputFormikField>
  )
}
